const GET_DATA_VESSEL = 'GET_DATA_VESSEL'
const GET_VESSEL_TYPE = 'GET_VESSEL_TYPE'
const GET_VESSEL_SIZE = 'GET_VESSEL_SIZE'
const GET_DETAIL_VESSEL = 'GET_DETAIL_VESSEL'
const GET_VESSEL_CATEGORY = 'GET_VESSEL_CATEGORY'
const GET_ATTACHMENT_FILE = 'GET_ATTACHMENT_FILE'

export { GET_DATA_VESSEL, GET_DETAIL_VESSEL, GET_VESSEL_CATEGORY, GET_VESSEL_SIZE, GET_VESSEL_TYPE, GET_ATTACHMENT_FILE }
